import { apiFetch, apiPost, apiPatch, apiDelete } from '@/lib/api-client';

export async function sendMessage(data: {
  name: string;
  email: string;
  subject?: string;
  message: string;
}) {
  return apiPost<{ success: boolean; error?: string }>('/api/messages', data);
}

export async function getMessages() {
  try {
    return await apiFetch<any[]>('/api/messages');
  } catch {
    return [];
  }
}

export async function markMessageAsRead(id: string) {
  return apiPatch(`/api/messages/${id}/read`);
}

export async function updateMessageStatus(id: string, status: string) {
  return apiPatch(`/api/messages/${id}/status`, { status });
}

export async function deleteMessage(id: string) {
  return apiDelete(`/api/messages/${id}`);
}
